import { Injectable } from '@angular/core';
import { ProfileStoreService } from '../profile-store/profile-store.service';
import { OrderInfo } from './order-info';

@Injectable()
export class ActiveViewStoreService {
  private viewId = '';

  constructor(private profileStore: ProfileStoreService) {}

  setCurrentViewId(viewId: string) {
    this.viewId = viewId;
  }

  restoreSelectedOrder(): Promise<OrderInfo> {
    return new Promise<OrderInfo>((resolve, reject) => {
      this.profileStore.restoreSelectedOrder(this.viewId).subscribe(result => {
        resolve(JSON.parse(result));
      });
    });
  }

  storeSelectedOrder(order: OrderInfo) {
    this.profileStore.storeSelectedOrder(this.viewId, JSON.stringify(order)).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/active-view-store/active-view-store.service.ts